import styled from 'styled-components';
import { button } from '../../utils/css';

export default styled.button`
	${button} background-color: transparent;
	${(props) => (props.primary ? `color: ${props.theme.color.primary}` : '')};
	${(props) => (props.bold ? 'font-weight: bold' : '')};
`;
